export const getMerlotFranceData = () => ({
  name: "Merlot",
  country: "France",
  description: "Le Merlot est le cépage dominant de la rive droite bordelaise, produisant des vins élégants et accessibles.",
  regions: [
    { name: "Saint-Émilion", area: "12,000 ha", percentage: "35%", description: "Cépage principal" },
    { name: "Pomerol", area: "8,000 ha", percentage: "23%", description: "Cépage dominant" },
    { name: "Fronsac", area: "6,000 ha", percentage: "17%", description: "Vins d'assemblage" },
    { name: "Lalande-de-Pomerol", area: "4,000 ha", percentage: "11%", description: "Usage principal" },
    { name: "Autres", area: "5,000 ha", percentage: "14%", description: "Dispersé dans le Bordelais" }
  ],
  mapAreas: [
    { region: "Saint-Émilion", x: 35, y: 72, color: "#4B164C", size: 7 },
    { region: "Pomerol", x: 33, y: 73, color: "#6d2c7a", size: 6 },
    { region: "Fronsac", x: 32, y: 71, color: "#8a4a8a", size: 5 },
    { region: "Lalande-de-Pomerol", x: 34, y: 72, color: "#a768a6", size: 4 }
  ],
  subregions: {
    bordeaux: {
      name: "Bordeaux",
      description: "Le Merlot est le cépage dominant de la rive droite bordelaise, produisant des vins élégants et accessibles.",
      characteristics: {
        aromas: "Prune, mûre, cèdre, truffe, notes florales",
        body: "Corps moyen à plein",
        tannins: "Tannins doux et soyeux",
        aging: "Vieillissement moyen (8-20 ans)"
      },
      terroir: {
        climate: "Climat océanique tempéré",
        soil: "Argiles et limons de la rive droite",
        viticulture: "Rendements modérés, vendanges manuelles"
      },
      differentiators: [
        "Élégance et finesse uniques",
        "Tannins naturellement doux",
        "Complexité aromatique développée",
        "Équilibre parfait fruité-structure"
      ],
      foodPairing: "Viandes blanches, volailles, fromages doux"
    }
  }
}); 